import { useEffect, useState } from 'react'
import api from '@/lib/api'

/**
 * Is the current user a franchise (reseller) admin? Drives the franchise
 * console nav and route guards. Resolved once per session from the server —
 * the client never decides this itself.
 */
let cached: boolean | null = null

export function useFranchise(): { isFranchiseAdmin: boolean; loading: boolean } {
  const [state, setState] = useState<{ isFranchiseAdmin: boolean; loading: boolean }>(() =>
    cached === null ? { isFranchiseAdmin: false, loading: true } : { isFranchiseAdmin: cached, loading: false }
  )

  useEffect(() => {
    if (cached !== null) return
    let cancelled = false
    api
      .get('/api/franchise/whoami')
      .then(res => {
        cached = !!res.data?.isFranchiseAdmin
        if (!cancelled) setState({ isFranchiseAdmin: cached, loading: false })
      })
      .catch(() => {
        cached = false
        if (!cancelled) setState({ isFranchiseAdmin: false, loading: false })
      })
    return () => {
      cancelled = true
    }
  }, [])

  return state
}
